import { render, staticRenderFns } from "./PostersEdit.vue?vue&type=template&id=24024e74&scoped=true&"
import script from "./PostersEdit.vue?vue&type=script&lang=js&"
export * from "./PostersEdit.vue?vue&type=script&lang=js&"
import style0 from "./PostersEdit.vue?vue&type=style&index=0&id=24024e74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24024e74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24024e74')) {
      api.createRecord('24024e74', component.options)
    } else {
      api.reload('24024e74', component.options)
    }
    module.hot.accept("./PostersEdit.vue?vue&type=template&id=24024e74&scoped=true&", function () {
      api.rerender('24024e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/PostersEdit.vue"
export default component.exports